import { useCompleteFragment } from '@eluve/apollo-client';
import { graphql } from '@eluve/graphql.tada';

import { useAppointmentId } from './appointment.context';

const appointmentLocationIdFragment = graphql(`
  fragment AppointmentLocationId on Appointments {
    __typename
    id
    locationId
  }
`);

export const useAppointmentLocationId = () => {
  const appointmentId = useAppointmentId();

  const data = useCompleteFragment({
    fragment: appointmentLocationIdFragment,
    key: {
      id: appointmentId,
    },
    strict: false,
  });

  return data?.locationId ?? '';
};
